export default "__VITE_ASSET__$u7fAks8__"